export const getOccupancyTotals = (rooms) => {
    return Object.assign({ rooms: rooms.length }, rooms.reduce((acc, cur) => {
        return {
            adults: acc.adults + cur.adults,
            children: acc.children + cur.childAges.length,
        };
    }, { adults: 0, children: 0 }));
};
const formatPluralizedCount = (count, singular, plural) => {
    return count > 0 ? `${count} ${count === 1 ? singular : plural}` : null;
};
const getSummary = (...parts) => {
    return parts.filter((part) => part !== null).join(', ');
};
export const getOccupancySummary = (rooms, resourceStrings, cabinText = '', excludeRoomSummary = false, totalNights = 0, toLowerCase = false) => {
    const totals = getOccupancyTotals(rooms);
    const { ADULT, ADULTS, CHILDREN, CHILD, ROOMS, ROOM, NIGHT, NIGHTS } = resourceStrings;
    const summary = getSummary(...[
        formatPluralizedCount(totalNights, NIGHT, NIGHTS),
        formatPluralizedCount(totals.adults, ADULT, ADULTS),
        formatPluralizedCount(totals.children, CHILD, CHILDREN),
        excludeRoomSummary ? null : formatPluralizedCount(totals.rooms, ROOM, ROOMS),
        cabinText || null,
    ]);
    return toLowerCase ? summary.toLowerCase() : summary;
};
export const getPassengerOccupancySummary = (adults, childAges, resourceStrings, cabinText) => {
    const { ADULT, ADULTS, CHILDREN, CHILD } = resourceStrings;
    return getSummary(...[
        formatPluralizedCount(adults, ADULT, ADULTS),
        formatPluralizedCount(childAges === null || childAges === void 0 ? void 0 : childAges.length, CHILD, CHILDREN),
        cabinText || null,
    ]);
};
